import { UUID } from './uuid';
import { Named } from '../base/named';
import { Metamodel } from '../base/model';

export const IDENTITY_KEY = '_identity$';

export const generateIdentity = (type: string, unique: string): string => {
    if (!type || !unique) {
        throw new Error('Error creating resource identifier.');
    }
    return `${type.toLowerCase()}$$${unique.toLowerCase()}`;
};

export const setIdentity = (named: Named, identity: string, forceSet?: boolean): string => {
    if (forceSet || !named.extension[IDENTITY_KEY]) {
        named.extension[IDENTITY_KEY] = identity;
    }
    return named.extension[IDENTITY_KEY] as string;
};

export const getIdentity = (named: Named): string => named.extension[IDENTITY_KEY] as string;

/**
 * @deprecated Use IdentityService instead
 */
export class Identifier {

    private constructor() { }

    public static getResourceIdentifier(resourceType: string, resourceName: string): string {
        if (!resourceType || !resourceName) {
            throw new Error('Error creating resource identifier.');
        }
        return `${resourceType.toLowerCase()}$$${resourceName.toLowerCase()}`;
    }

    /*
        Identifies a named and returns the identity used to identify
    */
    public static identify(named: Named): string {
        if (!named.extension._identity$) {
            const model = Metamodel.modelOf(named);
            // for non-root nameds fall back to uuid (for safety)
            named.extension._identity$ = model && model.concept && model.concept.name && named.name ?
                this.getResourceIdentifier(model.concept.name, named.name) :
                UUID.uuid4();
        }
        return named.extension._identity$ as string;
    }

    /*
        Re-identifies a named and returns the new identity
    */
    public static reIdentify(named: Named): string {
        named.extension._identity$ = undefined;
        return this.identify(named);
    }

    public static anonymize(named: Named): void {
        delete named.extension._identity$;
    }

    /*
        Identifies a named and returns the identity used to identify
    */
    public static setIdentity(named: Named, name: string, forceSet?: boolean): string {
        if (forceSet || !named.extension._identity$) {
            named.extension._identity$ = name;
        }
        return named.extension._identity$ as string;
    }

    /*
        Returns the identity
    */
    public static identity(named: Named): string | undefined {
        return named.extension._identity$ as string;
    }
}
